import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Button } from "@link/ui";

// Deliberately opt-in display; no automatic clipboard, file or browser storage.
export function RecoveryPhrase({ phrase }: { phrase: string }) {
  const [visible, setVisible] = useState(false);
  return <div className="mt-4 space-y-3">
    <p className="text-xs leading-relaxed text-cloud-600">Anyone with these words can access your account. Write them down privately; don’t share them or include them in screenshots.</p>
    <Button type="button" variant="outline" size="sm" aria-expanded={visible} onClick={() => setVisible(!visible)}>{visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}{visible ? "Hide words" : "Show recovery phrase"}</Button>
    {visible && <ol className="grid grid-cols-2 gap-2 sm:grid-cols-3" aria-label="Emergency recovery phrase">{phrase.split(" ").map((word, index) => <li key={index} className="rounded-lg border border-cloud-200 bg-white p-2 text-sm text-cloud-800"><span className="mr-2 text-xs text-cloud-400">{index + 1}</span>{word}</li>)}</ol>}
  </div>;
}
